import { useEffect, useState } from "react";
import OrcamentoVendaService from "../../services/service.orcamentovenda";
import { Alert } from "react-bootstrap";
import T from "../../common/traducao";
import { LinearProgress, Typography } from "@mui/material";
import { toast } from "react-toastify";

const SolicitarPedido = ({id, onSolicitarPedido}) => {

    const [retornoPedidoSolicitado, setRetornoPedidoSolicitado] = useState('');
    const [retornoErroSolicitacaoPedido, setRetornoErroSolicitacaoPedido] = useState('');
    const [loading, setLoading] = useState(false);

    const constantes = T();

    async function SolicitarPedido() {

        setLoading(true);
        await OrcamentoVendaService.SolicitarPedido(id)
            .then((response) => {
                setRetornoPedidoSolicitado(`Gerado Pré pedido. Orçamento ${response.data.Id} gerado com sucesso para Pré-Pedido`);
                toast.success(`${constantes.PedidoSolicitado} ${response.data.Id}`);
                onSolicitarPedido && onSolicitarPedido(response.data.Id);
            })
            .catch((error) => {
                const _error =
                    error.code === "ERR_NETWORK"
                        ? "Server OffLine"
                        : error.response && error.response.data && error.response.data.error
                            ? error.response.data.error.message
                            : error.message;
                setRetornoErroSolicitacaoPedido(_error);
   
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        SolicitarPedido();
    }, [])


    return (
        <>
            <Typography sx={{fontSize: 18}}>{constantes.SolicitandoPedidoParaOrcamento} {id}</Typography>

            {retornoErroSolicitacaoPedido &&

                <Alert variant="danger">
                    {retornoErroSolicitacaoPedido}
                </Alert>}

            {retornoPedidoSolicitado &&
                <Alert variant="success">
                    {retornoPedidoSolicitado}
                </Alert>}

            {' '}
            {loading && <LinearProgress color="inherit"  />}

        </>
    )
}

export default SolicitarPedido;